module.exports = __webpack_public_path__ + "img/assets/select/violet-brush@2x.6ab2d5a903905fb058f60cb1740e51f1.webp";